export class UserSettings {
    test: string = "";
    isDefault: boolean = true;
    user_level: number = -1;
    user_email: string = "default_email";
    picture: string = "assets/images/no_image.svg";
    user_homepage: string = "default_homepage";
    user_country: string = "default_country";
    user_city: string = "default_city";
    user_zip: string = "default_zip";
    status: string = "default_status";
    follow_notification: number = -1;
    comment_notification: number = -1;
    newboard_notification: number = -1;
    show_social_media_accounts_on_profile: number = -1;
    privat_profil_privacy: number = -1;
    send_messages_privacy: number = -1;
    created_at: string = "0000-00-00 00:00:00";

    constructor(isDefault?:boolean, user_level?:number,follow_notification?:number,comment_notification?:number,newboard_notification?:number,show_social_media_accounts_on_profile?:number,privat_profil_privacy?:number,send_messages_privacy?:number,created_at?:string){
        if(isDefault != null){
            this.isDefault = isDefault;
        }
        if(user_level != null){
            this.user_level = user_level;
        }
        if(follow_notification != null){
            this.follow_notification = follow_notification;
        }
        if(comment_notification != null){
            this.comment_notification = comment_notification;
        }
        if(newboard_notification != null){
            this.newboard_notification = newboard_notification;
        }
        if(show_social_media_accounts_on_profile != null){
            this.show_social_media_accounts_on_profile = show_social_media_accounts_on_profile;
        }
        if(privat_profil_privacy != null){
            this.privat_profil_privacy = privat_profil_privacy;
        }
        if(send_messages_privacy != null){
            this.send_messages_privacy = send_messages_privacy;
        }
        if(created_at != null){
            this.created_at = created_at;
        }
    }
}